[
    {
        "id": "siem-2u",
        "name": "SIEM · 2U",
        "shortHandle": "SEC-SIEM-2U",
        "category": "Security",
        "groupId": "security-monitoring",
        "sizeU": 2,
        "imagePath": "/assets/hardware/appliance_siem_2u.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/appliance/monitoring/siem",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 600
        }
    },
    {
        "id": "security-2x1g-rj45-2x10g-sfp-plus",
        "name": "2×1G + 2×10G Security Gateway · 1U",
        "shortHandle": "SEC-2X1G-2X1",
        "category": "Security",
        "groupId": "security-gateways",
        "sizeU": 1,
        "imagePath": "/assets/hardware/appliance_2x1g_2x10g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/appliance/security-gateways/2-1g-2-10g-security-gateway",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 80,
            "forwardingGbps": 20,
            "inspectionGbps": 2
        }
    },
    {
        "id": "security-2x10g-sfp-plus-2x25g-sfp28",
        "name": "2×25G + 2×10G Security Gateway · 2U",
        "shortHandle": "SEC-2X25G-2X",
        "category": "Security",
        "groupId": "security-gateways",
        "sizeU": 2,
        "imagePath": "/assets/hardware/appliance_2x10g_2x25g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/appliance/security-gateways/2-25g-2-10g-security-gateway",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 400,
            "forwardingGbps": 80,
            "inspectionGbps": 25
        }
    },
    {
        "id": "security-4x100g-qsfp28",
        "name": "4×100G Security Gateway · 2U",
        "shortHandle": "SEC-4X100G-S",
        "category": "Security",
        "groupId": "security-gateways",
        "sizeU": 2,
        "imagePath": "/assets/hardware/appliance_4x100g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/appliance/security-gateways/4-100g-security-gateway",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 600,
            "forwardingGbps": 200,
            "inspectionGbps": 160
        }
    },
    {
        "id": "security-4x10g-sfp-plus",
        "name": "4×10G Security Gateway · 1U",
        "shortHandle": "SEC-4X10G-SE",
        "category": "Security",
        "groupId": "security-gateways",
        "sizeU": 1,
        "imagePath": "/assets/hardware/appliance_4x10g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/appliance/security-gateways/4-10g-security-gateway",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 250,
            "forwardingGbps": 40,
            "inspectionGbps": 10
        }
    },
    {
        "id": "edd-1x1g-wall-ont",
        "name": "1×1G Wall ONT",
        "shortHandle": "EDD-1G",
        "category": "EDD",
        "groupId": "edd",
        "sizeU": 1,
        "imagePath": "/assets/hardware/edd_1x1g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/edd/1-1g-wall-ont",
        "userPlaceable": false,
        "availability": {
            "sandbox": ["garage"],
            "fj1_garage_to_glory": ["garage"],
            "scenario_arm_race": ["garage"],
            "scenario_garage_to_glory_hard": ["garage"]
        },
        "performance": {
            "powerWatts": null
        }
    },
    {
        "id": "edd-2x10g-colo-cross-connect",
        "name": "2×10G Colo Cross-Connect",
        "shortHandle": "EDD-10G",
        "category": "EDD",
        "groupId": "edd",
        "sizeU": 1,
        "imagePath": "/assets/hardware/edd_2x10g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/edd/2-10g-colo-cross-connect",
        "userPlaceable": false,
        "availability": {
            "scenario_garage_to_glory_hard": ["small-colo"]
        },
        "performance": {
            "powerWatts": null
        }
    },
    {
        "id": "edd-2x1g-residential-gateway",
        "name": "2×1G Residential Gateway",
        "shortHandle": "EDD-2G",
        "category": "EDD",
        "groupId": "edd",
        "sizeU": 1,
        "imagePath": "/assets/hardware/edd_2x1g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/edd/2-1g-residential-gateway",
        "userPlaceable": false,
        "availability": {
            "sandbox": ["basement"],
            "fj1_garage_to_glory": ["basement"],
            "scenario_arm_race": ["basement"],
            "scenario_garage_to_glory_hard": ["basement"]
        },
        "performance": {
            "powerWatts": null
        }
    },
    {
        "id": "edd-4x100g-mmr-cross-connect",
        "name": "4×200G MMR Cross-Connect",
        "shortHandle": "EDD-100G",
        "category": "EDD",
        "groupId": "edd",
        "sizeU": 1,
        "imagePath": "/assets/hardware/edd_4x100g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/edd/4-100g-mmr-cross-connect",
        "userPlaceable": false,
        "availability": {
            "sandbox": ["small-campus"],
            "fj1_garage_to_glory": ["small-campus"],
            "scenario_arm_race": ["small-campus"],
            "scenario_garage_to_glory_hard": ["small-campus"]
        },
        "performance": {
            "powerWatts": null
        }
    },
    {
        "id": "edd-4x25g-1u-fibre-cross-connect",
        "name": "4×25G 1U Fibre Cross-Connect",
        "shortHandle": "EDD-25G",
        "category": "EDD",
        "groupId": "edd",
        "sizeU": 1,
        "imagePath": "/assets/hardware/edd_4x25g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/edd/4-25g-1u-fibre-cross-connect",
        "userPlaceable": false,
        "availability": {
            "sandbox": ["small-colo"],
            "fj1_garage_to_glory": ["small-colo"],
            "scenario_arm_race": ["small-colo"]
        },
        "performance": {
            "powerWatts": null
        }
    },
    {
        "id": "gateway-16x100g-8x400g-hyperscale-edge",
        "name": "16×100G + 8×400G Gateway · Hyperscale edge",
        "shortHandle": "GW-16X100G-8",
        "category": "Gateways",
        "groupId": "gateways",
        "sizeU": 1,
        "imagePath": "/assets/hardware/gateway_16x100g_8x400g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/gateway/16-100g-8-400g-gateway",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 900,
            "forwardingGbps": 3200
        }
    },
    {
        "id": "gateway-16x25g-2x100g-border-router",
        "name": "16×25G + 2×100G Gateway · Border router",
        "shortHandle": "GW-16X25G-2X",
        "category": "Gateways",
        "groupId": "gateways",
        "sizeU": 1,
        "imagePath": "/assets/hardware/gateway_16x25g_2x100g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/gateway/16-25g-2-100g-gateway",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 350,
            "forwardingGbps": 400
        }
    },
    {
        "id": "gateway-4x1g-2x10g-router",
        "name": "4×1G + 2×10G Gateway · Router",
        "shortHandle": "GW-4X1G-2X10",
        "category": "Gateways",
        "groupId": "gateways",
        "sizeU": 1,
        "imagePath": "/assets/hardware/gateway_4x1g_2x10g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/gateway/4-1g-2-10g-gateway",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["garage", "basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 35,
            "forwardingGbps": 8
        }
    },
    {
        "id": "gateway-8x10g-2x25g-router-firewall",
        "name": "8×10G + 2×25G Gateway · Router/firewall",
        "shortHandle": "GW-8X10G-2X2",
        "category": "Gateways",
        "groupId": "gateways",
        "sizeU": 1,
        "imagePath": "/assets/hardware/gateway_8x10g_2x25g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/gateway/8-10g-2-25g-gateway",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 140,
            "forwardingGbps": 120
        }
    },
    {
        "id": "gateway-8x1g-router",
        "name": "8×1G Gateway · Router",
        "shortHandle": "GW-8X1G-ROUT",
        "category": "Gateways",
        "groupId": "gateways",
        "sizeU": 1,
        "imagePath": "/assets/hardware/gateway_8x1g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/gateway/8-1g-gateway",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 30,
            "forwardingGbps": 6
        }
    },
    {
        "id": "arm-dual-socket-1u",
        "name": "ARM Dual-Socket · 1U",
        "shortHandle": "SRV-ARM-DUAL",
        "category": "Servers",
        "groupId": "servers-arm",
        "sizeU": 1,
        "imagePath": "/assets/hardware/host_arm_1u_2nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/arm/arm-1u-dual",
        "userPlaceable": true,
        "availability": {},
        "performance": {
            "powerWatts": 183,
            "vCpus": 32,
            "memoryGb": 128,
            "storageGb": 1000,
            "storageIops": 30000
        }
    },
    {
        "id": "arm-1u",
        "name": "ARM · 1U",
        "shortHandle": "ARM-1",
        "category": "Servers",
        "groupId": "servers-arm",
        "sizeU": 1,
        "imagePath": "/assets/hardware/host_arm_1u_1nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/arm/arm-1u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["garage", "basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 80,
            "vCpus": 8,
            "memoryGb": 16,
            "storageGb": 500,
            "storageIops": 8000
        }
    },
    {
        "id": "arm-dual-socket-2u",
        "name": "ARM Dual-Socket · 2U",
        "shortHandle": "ARM-DS",
        "category": "Servers",
        "groupId": "servers-arm",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_arm_2u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/arm/arm-2u-dual",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 731,
            "vCpus": 128,
            "memoryGb": 512,
            "storageGb": 8000,
            "storageIops": 60000
        }
    },
    {
        "id": "arm-2u",
        "name": "ARM · 2U",
        "shortHandle": "ARM-2",
        "category": "Servers",
        "groupId": "servers-arm",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_arm_2u_2nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/arm/arm-2u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 352,
            "vCpus": 64,
            "memoryGb": 128,
            "storageGb": 4000,
            "storageIops": 40000
        }
    },
    {
        "id": "balanced-x86-1u",
        "name": "Balanced x86 · 1U",
        "shortHandle": "X86-1",
        "category": "Servers",
        "groupId": "servers-balanced",
        "sizeU": 1,
        "imagePath": "/assets/hardware/host_balanced_1u_1nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/balanced/balanced-x86-1u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["garage", "basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 400,
            "vCpus": 16,
            "memoryGb": 64,
            "storageGb": 2000,
            "storageIops": 15000
        }
    },
    {
        "id": "balanced-x86-dual-socket-2u",
        "name": "Balanced x86 Dual-Socket · 2U",
        "shortHandle": "SRV-BALANCED",
        "category": "Servers",
        "groupId": "servers-balanced",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_balanced_2u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/balanced/balanced-x86-2u-dual",
        "userPlaceable": true,
        "availability": {},
        "performance": {
            "powerWatts": 629,
            "vCpus": 64,
            "memoryGb": 512,
            "storageGb": 4000,
            "storageIops": 60000
        }
    },
    {
        "id": "balanced-x86-2u",
        "name": "Balanced x86 · 2U",
        "shortHandle": "X86-2",
        "category": "Servers",
        "groupId": "servers-balanced",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_balanced_2u_2nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/balanced/balanced-x86-2u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 301,
            "vCpus": 32,
            "memoryGb": 128,
            "storageGb": 4000,
            "storageIops": 50000
        }
    },
    {
        "id": "compute-dense-1u",
        "name": "Compute Dense · 1U",
        "shortHandle": "CMP-1",
        "category": "Servers",
        "groupId": "servers-compute",
        "sizeU": 1,
        "imagePath": "/assets/hardware/host_compute_1u_2nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/compute/compute-1u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 295,
            "vCpus": 32,
            "memoryGb": 64,
            "storageGb": 1000,
            "storageIops": 30000
        }
    },
    {
        "id": "compute-dual-socket-2u",
        "name": "Compute Dual-Socket · 2U",
        "shortHandle": "CMP-DS",
        "category": "Servers",
        "groupId": "servers-compute",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_compute_2u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/compute/compute-2u-dual",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 1205,
            "vCpus": 128,
            "memoryGb": 512,
            "storageGb": 4000,
            "storageIops": 120000
        }
    },
    {
        "id": "compute-dense-2u",
        "name": "Compute Dense · 2U",
        "shortHandle": "CMP-2",
        "category": "Servers",
        "groupId": "servers-compute",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_compute_2u_2nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/compute/compute-2u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 589,
            "vCpus": 64,
            "memoryGb": 128,
            "storageGb": 2000,
            "storageIops": 60000
        }
    },
    {
        "id": "gpu-2x-2u",
        "name": "GPU · 2× 2U",
        "shortHandle": "SRV-GPU-2X-2",
        "category": "Servers",
        "groupId": "servers-gpu",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_gpu_2x_2u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/gpu/gpu-2-2u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 1500,
            "vCpus": 16,
            "memoryGb": 128,
            "storageGb": 4000,
            "storageIops": 50000,
            "gpuCount": 2,
            "gpuMemoryGb": 48,
            "gpuSlices": 6
        }
    },
    {
        "id": "gpu-4x-4u",
        "name": "GPU · 4× 4U",
        "shortHandle": "SRV-GPU-4X-4",
        "category": "Servers",
        "groupId": "servers-gpu",
        "sizeU": 4,
        "imagePath": "/assets/hardware/host_gpu_4x_4u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/gpu/gpu-4-4u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 2400,
            "vCpus": 64,
            "memoryGb": 512,
            "storageGb": 8000,
            "storageIops": 80000,
            "gpuCount": 4,
            "gpuMemoryGb": 192,
            "gpuSlices": 24
        }
    },
    {
        "id": "gpu-8x-7u",
        "name": "GPU · 8× 7U",
        "shortHandle": "SRV-GPU-8X-7",
        "category": "Servers",
        "groupId": "servers-gpu",
        "sizeU": 7,
        "imagePath": "/assets/hardware/host_gpu_8x_7u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/gpu/gpu-8-7u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 5500,
            "vCpus": 208,
            "memoryGb": 1600,
            "storageGb": 16000,
            "storageIops": 120000,
            "gpuCount": 8,
            "gpuMemoryGb": 640,
            "gpuSlices": 80
        }
    },
    {
        "id": "mainframe-4u",
        "name": "Mainframe · 4U",
        "shortHandle": "SRV-MAINFRAM",
        "category": "Servers",
        "groupId": "servers-mainframe",
        "sizeU": 4,
        "imagePath": "/assets/hardware/host_mainframe_4u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/mainframe/mainframe-4u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 1800,
            "vCpus": 48,
            "memoryGb": 1024,
            "storageGb": 8000,
            "storageIops": 150000
        }
    },
    {
        "id": "mainframe-7u",
        "name": "Mainframe · 7U",
        "shortHandle": "SRV-MAINFR-2",
        "category": "Servers",
        "groupId": "servers-mainframe",
        "sizeU": 7,
        "imagePath": "/assets/hardware/host_mainframe_7u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/mainframe/mainframe-7u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 3500,
            "vCpus": 96,
            "memoryGb": 3072,
            "storageGb": 16000,
            "storageIops": 300000
        }
    },
    {
        "id": "memory-optimised-1u",
        "name": "Memory Optimised · 1U",
        "shortHandle": "SRV-MEMORY-O",
        "category": "Servers",
        "groupId": "servers-memory",
        "sizeU": 1,
        "imagePath": "/assets/hardware/host_memory_1u_2nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/memory/memory-1u",
        "userPlaceable": true,
        "availability": {},
        "performance": {
            "powerWatts": 341,
            "vCpus": 32,
            "memoryGb": 512,
            "storageGb": 1000,
            "storageIops": 25000
        }
    },
    {
        "id": "memory-optimised-dual-socket-2u",
        "name": "Memory Optimised Dual-Socket · 2U",
        "shortHandle": "MEM-DS",
        "category": "Servers",
        "groupId": "servers-memory",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_memory_2u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/memory/memory-2u-dual",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 1578,
            "vCpus": 128,
            "memoryGb": 4096,
            "storageGb": 4000,
            "storageIops": 80000
        }
    },
    {
        "id": "memory-optimised-2u",
        "name": "Memory Optimised · 2U",
        "shortHandle": "MEM-2",
        "category": "Servers",
        "groupId": "servers-memory",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_memory_2u_2nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/memory/memory-2u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 683,
            "vCpus": 64,
            "memoryGb": 1024,
            "storageGb": 2000,
            "storageIops": 60000
        }
    },
    {
        "id": "risc-v-2u",
        "name": "RISC-V · 2U",
        "shortHandle": "SRV-RISC-V-2",
        "category": "Servers",
        "groupId": "servers-risc-v",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_riscv_2u_2nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/risc-v/risc-v-2u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 280,
            "vCpus": 32,
            "memoryGb": 128,
            "storageGb": 2000,
            "storageIops": 40000
        }
    },
    {
        "id": "risc-v-4u",
        "name": "RISC-V · 4U",
        "shortHandle": "SRV-RISC-V-4",
        "category": "Servers",
        "groupId": "servers-risc-v",
        "sizeU": 4,
        "imagePath": "/assets/hardware/host_riscv_4u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/risc-v/risc-v-4u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 620,
            "vCpus": 96,
            "memoryGb": 384,
            "storageGb": 4000,
            "storageIops": 60000
        }
    },
    {
        "id": "storage-1u",
        "name": "Storage · 1U",
        "shortHandle": "SRV-STORAGE",
        "category": "Servers",
        "groupId": "servers-storage",
        "sizeU": 1,
        "imagePath": "/assets/hardware/host_storage_1u_1nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/storage/storage-1u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 350,
            "vCpus": 8,
            "memoryGb": 32,
            "storageGb": 16000,
            "storageIops": 600
        }
    },
    {
        "id": "storage-2u",
        "name": "Storage · 2U",
        "shortHandle": "SRV-STORAG-2",
        "category": "Servers",
        "groupId": "servers-storage",
        "sizeU": 2,
        "imagePath": "/assets/hardware/host_storage_2u_2nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/storage/storage-2u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 800,
            "vCpus": 16,
            "memoryGb": 64,
            "storageGb": 96000,
            "storageIops": 1200
        }
    },
    {
        "id": "storage-4u",
        "name": "Storage · 4U",
        "shortHandle": "SRV-STORAG-3",
        "category": "Servers",
        "groupId": "servers-storage",
        "sizeU": 4,
        "imagePath": "/assets/hardware/host_storage_4u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/storage/storage-4u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 1500,
            "vCpus": 32,
            "memoryGb": 128,
            "storageGb": 240000,
            "storageIops": 2400
        }
    },
    {
        "id": "storage-7u",
        "name": "Storage · 7U",
        "shortHandle": "SRV-STORAG-4",
        "category": "Servers",
        "groupId": "servers-storage",
        "sizeU": 7,
        "imagePath": "/assets/hardware/host_storage_7u_4nic.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/host/storage/storage-7u",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 1800,
            "vCpus": 48,
            "memoryGb": 256,
            "storageGb": 720000,
            "storageIops": 7200
        }
    },
    {
        "id": "patch-panel-pp-24-patch-panel",
        "name": "PP-24 Patch Panel",
        "shortHandle": "PP-24",
        "category": "Patch panels",
        "groupId": "patch-panels",
        "sizeU": 1,
        "imagePath": "/assets/hardware/24xrj45-patch-panel.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/patch-panel/pp-24",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["garage", "basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": null
        }
    },
    {
        "id": "switch-32x100g-qsfp28-managed-l3",
        "name": "32×100G Spine",
        "shortHandle": "SW-32X100G-S",
        "category": "Switches",
        "groupId": "switches-100g-plus",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_spine_l3_32x100g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/100g-plus/32-100g-spine",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 450,
            "forwardingGbps": 3200
        }
    },
    {
        "id": "switch-32x200g-qsfp56-managed-l3",
        "name": "32×200G Spine",
        "shortHandle": "SW-32X200G-S",
        "category": "Switches",
        "groupId": "switches-100g-plus",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_spine_l3_32x200g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/100g-plus/32-200g-spine",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 550,
            "forwardingGbps": 6400
        }
    },
    {
        "id": "switch-2x25g-sfp28-32x400g-qsfp-dd-managed-l3",
        "name": "32×400G Spine",
        "shortHandle": "SW-32X400G-S",
        "category": "Switches",
        "groupId": "switches-100g-plus",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_spine_l3_32x400g_2x25g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/100g-plus/32-400g-spine",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 900,
            "forwardingGbps": 6400
        }
    },
    {
        "id": "switch-24x10g-sfp-plus-2x25g-sfp28-managed-l3",
        "name": "24×10G + 2×25G Access",
        "shortHandle": "SW-24X10G-2X",
        "category": "Switches",
        "groupId": "switches-10g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_access_l3_24x10g_2x25g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/10g/24-10g-2-25g-access",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 110,
            "forwardingGbps": 290
        }
    },
    {
        "id": "switch-36x10g-sfp-plus-2x25g-sfp28-managed-l3",
        "name": "36×10G + 2×25G Access",
        "shortHandle": "SW-36X10G-2X",
        "category": "Switches",
        "groupId": "switches-10g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_access_l3_36x10g_2x25g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/10g/36-10g-2-25g-access",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 150,
            "forwardingGbps": 410
        }
    },
    {
        "id": "switch-48x10g-4x40g-tor-mlag",
        "name": "48×10G + 4×40G ToR MLAG",
        "shortHandle": "SW-48X10G-4X",
        "category": "Switches",
        "groupId": "switches-10g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_tor_l3_48x10g_4x40g_mlag.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/10g/48-10g-4-40g-tor-mlag",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 230,
            "forwardingGbps": 640
        }
    },
    {
        "id": "switch-48x10g-sfp-plus-4x40g-qsfp-plus-managed-l3",
        "name": "48×10G + 4×40G ToR",
        "shortHandle": "SW-48X10G--2",
        "category": "Switches",
        "groupId": "switches-10g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_tor_l3_48x10g_4x40g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/10g/48-10g-4-40g-tor",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 220,
            "forwardingGbps": 640
        }
    },
    {
        "id": "switch-48x10g-sfp-plus-managed-l3",
        "name": "48×10G ToR",
        "shortHandle": "SW-48X10G-TO",
        "category": "Switches",
        "groupId": "switches-10g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_tor_l3_48x10g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/10g/48-10g-tor",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 180,
            "forwardingGbps": 480
        }
    },
    {
        "id": "switch-16x1g-rj45-managed-l2",
        "name": "16×1G Access",
        "shortHandle": "SW-16X1G",
        "category": "Switches",
        "groupId": "switches-1g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_access_l2_16x1g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/1g/16-port-access-gbe",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["garage", "basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 25,
            "forwardingGbps": 32
        }
    },
    {
        "id": "switch-24x1g-4x10g-mlag",
        "name": "24×1G + 4×10G MLAG",
        "shortHandle": "SW-24X1G-4X1",
        "category": "Switches",
        "groupId": "switches-1g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_access_l2_24x1g_4x10g_mlag.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/1g/24-1g-4-10g-mlag",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 52,
            "forwardingGbps": 64
        }
    },
    {
        "id": "switch-24x1g-rj45-2x10g-sfp-plus-managed-l2",
        "name": "24×1G + 2×10G Access",
        "shortHandle": "SW-24X1G-2X1",
        "category": "Switches",
        "groupId": "switches-1g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_access_l2_24x1g_2x10g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/1g/24-gbe-2-sfp-access",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 45,
            "forwardingGbps": 44
        }
    },
    {
        "id": "switch-24x1g-rj45-managed-l2",
        "name": "24×1G Access",
        "shortHandle": "SW-24X1G",
        "category": "Switches",
        "groupId": "switches-1g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_access_l2_24x1g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/1g/24-port-access-gbe",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["garage", "basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["garage", "basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 35,
            "forwardingGbps": 48
        }
    },
    {
        "id": "switch-48x1g-4x10g-mlag",
        "name": "48×1G + 4×10G MLAG",
        "shortHandle": "SW-48X1G-4X1",
        "category": "Switches",
        "groupId": "switches-1g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_access_l2_48x1g_4x10g_mlag.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/1g/48-1g-4-10g-mlag",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 68,
            "forwardingGbps": 88
        }
    },
    {
        "id": "switch-48x1g-rj45-4x10g-sfp-plus-managed-l2",
        "name": "48×1G + 4×10G Access",
        "shortHandle": "SW-48X1G-4-2",
        "category": "Switches",
        "groupId": "switches-1g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_access_l2_48x1g_4x10g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/1g/48-gbe-4-sfp-access",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["basement", "small-colo", "small-campus"],
            "scenario_arm_race": ["basement", "small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["basement", "small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 55,
            "forwardingGbps": 88
        }
    },
    {
        "id": "switch-24x40g-qsfp-plus-4x100g-qsfp28-managed-l3",
        "name": "24×40G + 4×100G Aggregation",
        "shortHandle": "SW-24X40G-4X",
        "category": "Switches",
        "groupId": "switches-25g-40g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_agg_l3_24x40g_4x100g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/25g-40g/24-40g-4-100g-aggregation",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 350,
            "forwardingGbps": 1360
        }
    },
    {
        "id": "switch-48x25g-6x100g-leaf-mlag",
        "name": "48×25G + 6×100G Leaf MLAG",
        "shortHandle": "SW-48X25G-6X",
        "category": "Switches",
        "groupId": "switches-25g-40g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_leaf_l3_48x25g_6x100g_mlag.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/25g-40g/48-25g-6-100g-leaf-mlag",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 335,
            "forwardingGbps": 1800
        }
    },
    {
        "id": "switch-48x25g-sfp28-6x100g-qsfp28-managed-l3",
        "name": "48×25G + 6×100G Leaf",
        "shortHandle": "SW-48X25G--2",
        "category": "Switches",
        "groupId": "switches-25g-40g",
        "sizeU": 1,
        "imagePath": "/assets/hardware/switch_leaf_l3_48x25g_6x100g.webp",
        "wikiUrl": "https://wiki.playuptime.com/hardware-reference/switch/25g-40g/48-25g-6-100g-leaf",
        "userPlaceable": true,
        "availability": {
            "fj1_garage_to_glory": ["small-colo", "small-campus"],
            "scenario_arm_race": ["small-colo", "small-campus"],
            "scenario_garage_to_glory_hard": ["small-colo", "small-campus"]
        },
        "performance": {
            "powerWatts": 320,
            "forwardingGbps": 1800
        }
    }
]
